/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TdbP1DonneesSitesResponseDto } from '../../models/tdb-p-1-donnees-sites-response-dto';

export interface GetTdbP1DonneesSites$Params {
  body: Array<string>;
}

export function getTdbP1DonneesSites(
  http: HttpClient,
  rootUrl: string,
  params: GetTdbP1DonneesSites$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<TdbP1DonneesSitesResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getTdbP1DonneesSites.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TdbP1DonneesSitesResponseDto>;
    })
  );
}

getTdbP1DonneesSites.PATH = '/v1/reportings_p1/tdb/sites';
